import React from "react";
import { Outlet, useParams } from "react-router-dom";
import "./AllPrograms.css";
import ProgNav from "./ProgNav";
import NewProgramSidebar from "./components/NewProgramSidebar";

const AllPrograms = () => {
  const { programId } = useParams();

  // If no programId is selected, render only the Outlet (landing page)
  if (!programId) {
    return <Outlet />;
  }

  return (
    <div className="all-programs-container">
      {/* Program Sidebar */}
      <NewProgramSidebar />

      {/* Main Content */}
      <div className="programs-content">
        <ProgNav />
        <Outlet />
      </div>
    </div>
  );
};

export default AllPrograms;
